export default {
    active: true,
    seed: 19,
    skyType: "atmosphere",
    skyColor: "#8cbdc8",
    horizonColor: "#ddd",
    lighting: "distant",
    lightPosition: { x: -0.11, y: 0.16, z: 0.33 },
    fog: 0.67,
    flatShading: true,
    playArea: 1,
    ground: "canyon",
    groundYScale: 10,
    groundTexture: "walkernoise",
    groundColor: "#a87d6f",
    groundColor2: "#795449",
    dressing: "arches",
    dressingAmount: 6,
    dressingColor: "#795449",
    dressingScale: 26,
    dressingVariance: { x: 20, y: 40, z: 20 },
    dressingUniformScale: true,
    dressingOnPlayArea: 0.04,
    grid: "none",
    gridColor: "#ccc",
    shadow: false,
};
